import axios from "axios";

export const getOrderHistoryList = async (
  email,
  filter = "all",
  startDate = null,
  endDate = null
) => {
  try {
    const params = { email: email, filter: filter };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await axios.get(`/api/OrderHistory/GetOrderList`, {
      params,
    });
    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Fail to fetch order list" };
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      return { status: false, message: "Unauthorized", statusCode: 401 };
    }
    return { status: false, message: error.message };
  }
};

export const getRenewOrderList = async (
  email,
  filter = "all",
  startDate = null,
  endDate = null
) => {
  try {
    const params = { email: email, filter: filter };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await axios.get(`/api/OrderHistory/GetRenewOrderList`, {
      params,
    });
    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Fail to fetch order list" };
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      return { status: false, message: "Unauthorized", statusCode: 401 };
    }
    return { status: false, message: error.message };
  }
};

export const getJoyTelOrderHistoryList = async (
  email,
  filter = "all",
  startDate = null,
  endDate = null
) => {
  try {
    const params = { email: email, filter: filter };
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axios.get(`/api/OrderHistory/GetJoyTelOrderList`, {
      params,
    });
    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Fail to fetch JoyTel order list" };
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      return { status: false, message: "Unauthorized", statusCode: 401 };
    }
    return { status: false, message: error.message };
  }
};

// Add this function after getJoyTelOrderHistoryList
export const getJoyTelDataUsage = async (snCode) => {
  try {
    const response = await axios.post(`/api/JoyTel/queryDataUsage`, {
      coupon: snCode,
    });
    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Fail to fetch JoyTel data usage" };
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      return { status: false, message: "Unauthorized", statusCode: 401 };
    }
    return { status: false, message: error.message };
  }
};

// Get Roam order from database by orderNum
export const getOrderByOrderNum = async (email, orderNum) => {
  try {
    const response = await axios.get(
      `/api/OrderHistory/GetRoamOrderByOrderNum`,
      {
        params: { email, orderNum },
      }
    );

    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Failed to fetch order info" };
    }
  } catch (error) {
    console.error("GetOrderByOrderNum Error:", error);

    if (error.response) {
      if (error.response.status === 401) {
        return { status: false, message: "Unauthorized", statusCode: 401 };
      }
      if (error.response.status === 404) {
        return { status: false, message: "Order not found" };
      }
      // Return error message from backend if available
      if (error.response.data && error.response.data.message) {
        return { status: false, message: error.response.data.message };
      }
    }

    return { status: false, message: error.message || "An error occurred" };
  }
};

// Get JoyTel order by orderTid
export const getJoyTelOrderByOrderTid = async (email, orderTid) => {
  try {
    const response = await axios.get(
      `/api/OrderHistory/GetJoyTelOrderByOrderTid`,
      {
        params: { email, orderTid },
      }
    );

    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Failed to fetch order info" };
    }
  } catch (error) {
    console.error("GetJoyTelOrderByOrderTid Error:", error);

    if (error.response) {
      if (error.response.status === 401) {
        return { status: false, message: "Unauthorized", statusCode: 401 };
      }
      if (error.response.status === 404) {
        return { status: false, message: "Order not found" };
      }
      if (error.response.data && error.response.data.message) {
        return { status: false, message: error.response.data.message };
      }
    }

    return { status: false, message: error.message || "An error occurred" };
  }
};

// Retry JoyTel order callback
export const retryJoyTelOrder = async (orderTid, orderCode) => {
  try {
    const response = await axios.post(`/api/OrderHistory/RetryJoyTelOrder`, {
      orderTid,
      orderCode,
    });

    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Failed to retry order" };
    }
  } catch (error) {
    console.error("RetryJoyTelOrder Error:", error);

    if (error.response && error.response.data) {
      return {
        status: false,
        message: error.response.data.message || "Failed to retry order",
      };
    }

    return { status: false, message: error.message || "An error occurred" };
  }
};

// Add this new function for renewal orders
export const processRenewalOrder = async (renewalOrderData) => {
  try {
    const response = await axios.post("/api/esim/renewal", renewalOrderData);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.error("ProcessRenewalOrder Error:");
      return { status: false, message: "Failed to process renewal order" };
    }
  } catch (error) {
    console.error("ProcessRenewalOrder exception:", error);
    if (error.response && error.response.status === 401) {
      return { status: false, message: "Unauthorized", statusCode: 401 };
    }
    // Return actual backend error message for 400/500 errors
    if (error.response && error.response.data) {
      return {
        status: false,
        message:
          error.response.data.message || error.message || "An error occurred",
      };
    }
    return { status: false, message: error.message || "An error occurred" };
  }
};

export const getRenewalOrdersByMainOrderNum = async (mainOrderNum) => {
  try {
    const response = await axios.get(
      "/api/OrderHistory/GetRenewalOrdersByMainOrderNum",
      {
        params: { mainOrderNum },
      }
    );

    if (response && response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("GetRenewalOrdersByMainOrderNum Error:", error);

    if (error.response) {
      if (error.response.status === 401) {
        return { status: false, message: "Unauthorized", statusCode: 401 };
      }
      if (error.response.status === 404) {
        return { status: false, message: "Renewal order not found" };
      }
      if (error.response.data && error.response.data.message) {
        return { status: false, message: error.response.data.message };
      }
    }

    return { status: false, message: error.message || "An error occurred" };
  }
};

// Get Renew order from database by orderNum
export const getRenewOrderByOrderNum = async (email, orderNum) => {
  try {
    const response = await axios.get(
      `/api/OrderHistory/GetRenewalOrderByOrderNum`,
      {
        params: { email, orderNum },
      }
    );

    if (response && response.status === 200) {
      return response.data;
    } else {
      return { status: false, message: "Failed to fetch renewal order info" };
    }
  } catch (error) {
    console.error("GetRenewOrderByOrderNum Error:", error);

    if (error.response) {
      if (error.response.status === 401) {
        return { status: false, message: "Unauthorized", statusCode: 401 };
      }
      if (error.response.status === 404) {
        return { status: false, message: "Renewal order not found" };
      }
      if (error.response.data && error.response.data.message) {
        return { status: false, message: error.response.data.message };
      }
    }

    return { status: false, message: error.message || "An error occurred" };
  }
};

// Redeem coupon to get activation code
// export const redeemJoyTelCoupon = async (coupon) => {
//   try {
//     const response = await axios.post(`/api/JoyTel/redeem`, {
//       coupon
//     });

//     if (response && response.status === 200) {
//       return response.data;
//     } else {
//       return { status: false, message: "Failed to redeem coupon" };
//     }
//   } catch (error) {
//     console.error("RedeemJoyTelCoupon Error:", error);

//     if (error.response) {
//       if (error.response.status === 401) {
//         return { status: false, message: "Unauthorized", statusCode: 401 };
//       }
//       if (error.response.data && error.response.data.message) {
//         return { status: false, message: error.response.data.message };
//       }
//     }

//     return { status: false, message: error.message || "An error occurred" };
//   }
// };

export const getRoamCardInfo = async (orderNum, backInfo = "1") => {
  try {
    const params = { orderNum };
    if (backInfo) {
      params.backInfo = backInfo;
    }

    const response = await axios.get(`/api/Roam/esim-card-info`, { params });

    if (response && response.status == 200) {
      return response.data;
    } else {
      return { status: false, message: "Fail to fetch esim card info" };
    }
  } catch (error) {
    if (error.response && error.response.status == 401) {
      return { status: false, message: "Unauthorized", statusCode: 401 };
    }
    return { status: false, message: error.message };
  }
};

export const redeemRetry = async (orderTid) => {
  try {
    const response = await axios.post('/api/OrderHistory/RedeemRetry', { orderTid });
    if (response && response.status === 200) {
      return response.data;
    }
    return { status: false, message: 'Failed to initiate redeem' };
  } catch (error) {
    console.error('RedeemRetry error:', error);
    if (error.response && error.response.data) {
      return { status: false, message: error.response.data.message || 'Failed to initiate redeem' };
    }
    return { status: false, message: error.message || 'An error occurred' };
  }
};

export const redeemQuery = async (orderTid) => {
  try {
    const response = await axios.post('/api/OrderHistory/RedeemQuery', { orderTid });
    if (response && response.status === 200) {
      return response.data;
    }
    return { status: false, message: 'Failed to query redeem' };
  } catch (error) {
    console.error('RedeemQuery error:', error);
    if (error.response && error.response.data) {
      return { status: false, message: error.response.data.message || 'Failed to query redeem' };
    }
    return { status: false, message: error.message || 'An error occurred' };
  }
};
// export const getEsimOrderList = async (startDate, endDate, pageSize = 5) => {
//   try {
//     const params = {
//       startDate: startDate,
//       endDate: endDate,
//       pageSize: pageSize,
//     };

//     const response = await axios.get(`/api/Roam/order-list`, { params });

//     if (response && response.status === 200) {
//       return response.data;
//     } else {
//       return { status: false, message: "Fail to fetch orderlist" };
//     }
//   } catch (error) {
//     if (error.response && error.response.status === 401) {
//       return { status: false, message: "Unauthorized", statusCode: 401 };
//     }

//     return { status: false, message: error.message };
//   }
// }

// export const getEsimOrderCardInfoList = async (orderParams = {}) => {
//   try {
//     const response = await axios.get(`/api/Roam/esimCardOrderInfoList`, {
//       params: orderParams,
//     });

//     if (response && response.status === 200) {
//       return response.data;
//     } else {
//       return { status: false, message: "Fail to fetch esim card order info" };
//     }
//   } catch (error) {
//     if(error.response && error.response.status === 401){
//         return {status:false, message:"Unauthorized", statusCode: 401};
//     }

//     return {status:false, message: error.message};
//   }
// }

// export const getOrderInfo = async (orderNum) => {
//     try {
//         const response = await axios.get(`/api/Roam/order-info`, {
//             params: { orderNum }
//         });

//         if (response && response.status === 200) {
//             return response.data;
//         } else {
//             console.error("GetOrderInfo Error:", response.status);
//             return { status: false, message: "Failed to fetch order info" };
//         }
//     } catch (error) {
//         console.error("GetOrderInfo Error:", error);
//         if (error.response && error.response.status === 401) {
//             return { status: false, message: "Unauthorized", statusCode: 401 };
//         }
//         return { status: false, message: error.message || "An error occurred" };
//     }
// };
